export const getUtcDateIsoString = () => new Date().toISOString();
